import React from 'react';
import { DiagramNotFoundBody, DisplayNotFoundText } from './NotFound.styled';
import { ReactComponent as DiagramNotFound } from '../../assets/icons/not-found.svg';

interface NotFoundI {
  text: string;
}

const NotFound = ({ text }: NotFoundI) => {
  return (
    <DiagramNotFoundBody>
      <DiagramNotFound width="150px" height="150px" />
      <DisplayNotFoundText>{text}</DisplayNotFoundText>
    </DiagramNotFoundBody>
  );
};

export default NotFound;
